import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import useOrderData from "@/hooks/data/use-orders-data";
import { IOrder } from "@/interfaces/order.interfaces";
import { OrderBillingMessages } from "@/messages/order-details/order-billing.messages";

type Props = {
  messages: OrderBillingMessages;
  order: IOrder | null;
};

export default function BillingInformation({ messages, order }: Props) {
  const data = useOrderData({ order });
  const { billingName, formattedBillingAddress, billingAddressCity, billingAddressZipcode } = data;

  return (
    <>
      <MDTypography variant="h6" fontWeight="medium">
        {messages.billingInformationTitle}
      </MDTypography>

      <MDBox
        component="li"
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
        bgColor={"grey-100"}
        borderRadius="lg"
        p={3}
        mt={2}
      >
        <MDBox width="100%" display="flex" flexDirection="column" lineHeight={1}>
          <MDBox mb={2}>
            <MDTypography
              variant="body2"
              fontWeight="medium"
              textTransform="capitalize"
              color="text"
            >
              {billingName}
            </MDTypography>
          </MDBox>

          <MDBox mb={1} lineHeight={0}>
            <MDTypography variant="caption" fontWeight="regular" color="text">
              {messages.billingAddressLabel}:&nbsp;&nbsp;&nbsp;
              <MDTypography variant="caption" fontWeight="medium">
                {formattedBillingAddress}
              </MDTypography>
            </MDTypography>
          </MDBox>

          <MDBox mb={1} lineHeight={0}>
            <MDTypography variant="caption" fontWeight="regular" color="text">
              {messages.billingDistrictLabel}:&nbsp;&nbsp;&nbsp;
              <MDTypography variant="caption" fontWeight="medium">
                {order?.billingAddressDistrict}
              </MDTypography>
            </MDTypography>
          </MDBox>

          <MDBox mb={1} lineHeight={0}>
            <MDTypography variant="caption" fontWeight="regular" color="text">
              {messages.billingCityLabel}:&nbsp;&nbsp;&nbsp;
              <MDTypography variant="caption" fontWeight="medium">
                {billingAddressCity}
              </MDTypography>
            </MDTypography>
          </MDBox>

          <MDTypography variant="caption" fontWeight="regular" color="text">
            {messages.billingZipCodeLabel}:&nbsp;&nbsp;&nbsp;
            <MDTypography variant="caption" fontWeight="medium">
              {billingAddressZipcode}
            </MDTypography>
          </MDTypography>
        </MDBox>
      </MDBox>
    </>
  );
}
